var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02IconoProgramaInsignias(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 157.832,
    height: 137.611,
    viewBox: "0 0 157.832 137.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "etapas",
    transform: "translate(1 2.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 66.306,
    cy: 66.306,
    r: 66.306,
    transform: "translate(21.721)",
    fill: "none",
    stroke: "#f0f4f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    strokeDasharray: "1 12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0 44.585)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    "data-name": "Oval",
    cx: 21.721,
    cy: 21.721,
    r: 21.721,
    fill: "#fdfffc",
    stroke: "#f0f4f9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M7.434,13.718a1.43,1.43,0,0,1-1.1-.473L.447,7.2A1.524,1.524,0,0,1,.5,5a1.524,1.524,0,0,1,2.206.052L7.487,9.988,17.574.427a1.561,1.561,0,1,1,2.154,2.259L8.538,13.3A1.806,1.806,0,0,1,7.434,13.718Z",
    transform: "translate(11.432 14.862)",
    fill: "#7821a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_53",
    "data-name": "Grupo 53",
    transform: "translate(-20.975 -191.644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_50",
    "data-name": "Grupo 50",
    transform: "translate(76.876 218.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_369",
    "data-name": "Trazado 369",
    d: "M146.863,265.151v7.127h-68.9v-7.127a4.752,4.752,0,0,1,4.752-4.752h59.4a4.75,4.75,0,0,1,4.751,4.752Z",
    transform: "translate(-77.964 -239.017)",
    fill: "#a4c2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_370",
    "data-name": "Trazado 370",
    d: "M143.3,265.151v7.127H77.964v-7.127a4.752,4.752,0,0,1,4.752-4.752h55.832a4.751,4.751,0,0,1,4.751,4.752Z",
    transform: "translate(-77.964 -239.017)",
    fill: "#d4e1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_371",
    "data-name": "Trazado 371",
    d: "M146.863,278.6v33.261a4.751,4.751,0,0,1-4.751,4.752h-59.4a4.751,4.751,0,0,1-4.751-4.752V278.6Z",
    transform: "translate(-77.964 -247.718)",
    fill: "#a4c2f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_49",
    "data-name": "Grupo 49",
    transform: "translate(0 30.886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_372",
    "data-name": "Trazado 372",
    d: "M143.3,278.6v33.261a4.752,4.752,0,0,1-4.752,4.752H82.715a4.751,4.751,0,0,1-4.751-4.752V278.6Z",
    transform: "translate(-77.964 -278.604)",
    fill: "#e3e7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_373",
    "data-name": "Trazado 373",
    d: "M90.53,292.257h19.006a1.188,1.188,0,0,1,1.188,1.188v21.382a1.188,1.188,0,0,1-1.188,1.188H90.53a1.188,1.188,0,0,1-1.188-1.188V293.445A1.188,1.188,0,0,1,90.53,292.257Z",
    transform: "translate(-83.402 -285.13)",
    fill: "#f1eaf4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_374",
    "data-name": "Trazado 374",
    d: "M131.49,219.439h11.879a1.188,1.188,0,0,1,1.188,1.188v23.758a1.188,1.188,0,0,1-1.188,1.188H131.49a1.188,1.188,0,0,1-1.188-1.188V220.627A1.188,1.188,0,0,1,131.49,219.439Z",
    transform: "translate(-102.98 -219.439)",
    fill: "#a4c2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_375",
    "data-name": "Trazado 375",
    d: "M131.49,219.439h8.315a1.188,1.188,0,0,1,1.188,1.188v23.758a1.188,1.188,0,0,1-1.188,1.188H131.49a1.188,1.188,0,0,1-1.188-1.188V220.627A1.188,1.188,0,0,1,131.49,219.439Z",
    transform: "translate(-102.98 -219.439)",
    fill: "#d4e1f4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_83",
    "data-name": "Elipse 83",
    cx: 2.376,
    cy: 2.376,
    r: 2.376,
    transform: "translate(32.074 16.631)",
    fill: "#a4c2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_376",
    "data-name": "Trazado 376",
    d: "M110.559,321.453a2.786,2.786,0,0,0-.713-.57l-4.8-2.732a.417.417,0,0,1-.2-.357v-1.283a.428.428,0,0,1,.071-.238,6.053,6.053,0,0,0,1.164-2.34,1.519,1.519,0,0,1,.44-.8,1.513,1.513,0,0,0,.475-1.093v-1.461a1.561,1.561,0,0,0-.166-.7l-.1-.167a1.548,1.548,0,0,1-.167-.689v-2.1a3.374,3.374,0,0,0-3.457-3.29h-2.59a3.375,3.375,0,0,0-3.457,3.29v2.1a1.548,1.548,0,0,1-.166.689l-.1.167a1.561,1.561,0,0,0-.166.7v1.461a1.513,1.513,0,0,0,.475,1.093,1.516,1.516,0,0,1,.44.8,6.052,6.052,0,0,0,1.164,2.34.433.433,0,0,1,.072.238v1.283a.418.418,0,0,1-.2.357l-4.8,2.732a2.786,2.786,0,0,0-.713.57Z",
    transform: "translate(-85.186 -259.682)",
    fill: "#efd2ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_377",
    "data-name": "Trazado 377",
    d: "M82.715,307.916h3.564a4.751,4.751,0,0,1-4.751-4.752V265.151a4.751,4.751,0,0,1,4.751-4.752H82.715a4.751,4.751,0,0,0-4.751,4.752v38.013a4.751,4.751,0,0,0,4.751,4.752Z",
    transform: "translate(-1.088 -20.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_52",
    "data-name": "Grupo 52",
    transform: "translate(75.688 217.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_378",
    "data-name": "Trazado 378",
    d: "M75.689,307.515V269.5h2.376v38.013Z",
    transform: "translate(-75.688 -242.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_51",
    "data-name": "Grupo 51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_379",
    "data-name": "Trazado 379",
    d: "M76.425,324.121a.738.738,0,0,0,.214.07,1.741,1.741,0,0,0,.238.024,1.248,1.248,0,0,0,.844-.345,1.171,1.171,0,0,0-.392-1.936,1.179,1.179,0,0,0-.452-.1,1.252,1.252,0,0,0-.844.345,1.2,1.2,0,0,0,0,1.687l.178.143A.909.909,0,0,0,76.425,324.121Z",
    transform: "translate(-75.688 -267.196)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_380",
    "data-name": "Trazado 380",
    d: "M141.023,238.546H119.641V219.539a2.379,2.379,0,0,0-2.376-2.376H105.386a2.379,2.379,0,0,0-2.376,2.376v19.006H81.628a5.947,5.947,0,0,0-5.94,5.94v23.758a1.188,1.188,0,1,0,2.376,0V250.425h66.523V282.5a3.568,3.568,0,0,1-3.564,3.564h-59.4a3.567,3.567,0,0,1-3.563-3.564v-4.751a1.188,1.188,0,1,0-2.376,0V282.5a5.946,5.946,0,0,0,5.939,5.94h59.4a5.946,5.946,0,0,0,5.94-5.94V244.485A5.946,5.946,0,0,0,141.023,238.546Zm-35.637-19.006h11.879l0,20.185,0,.009,0,.01V243.3H105.386V219.539Zm-27.322,28.51v-3.564a3.567,3.567,0,0,1,3.563-3.564H103.01V243.3a2.379,2.379,0,0,0,2.376,2.376h11.879a2.38,2.38,0,0,0,2.376-2.376v-2.376h21.382a3.568,3.568,0,0,1,3.564,3.564v3.564Z",
    transform: "translate(-75.688 -217.163)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_381",
    "data-name": "Trazado 381",
    d: "M108.449,316.116a2.379,2.379,0,0,0,2.376-2.376V292.358a2.379,2.379,0,0,0-2.376-2.376H89.442a2.379,2.379,0,0,0-2.376,2.376V313.74a2.38,2.38,0,0,0,2.376,2.376Zm-11.66-7.09a4.911,4.911,0,0,1-.943-1.85,2.7,2.7,0,0,0-.78-1.42.327.327,0,0,1-.111-.237v-1.462c0-.055.013-.11.01-.11h0l.128-.225a2.759,2.759,0,0,0,.291-1.22v-2.1a2.193,2.193,0,0,1,2.269-2.1h2.589a2.193,2.193,0,0,1,2.269,2.1v2.1a2.8,2.8,0,0,0,.324,1.28l.062.1a.377.377,0,0,1,.043.171v1.462a.317.317,0,0,1-.1.228,2.692,2.692,0,0,0-.784,1.406,5.082,5.082,0,0,1-.994,1.938,1.618,1.618,0,0,0-.269.893v1.283a1.63,1.63,0,0,0,.8,1.389l1.9,1.082H94.4l1.951-1.111a1.6,1.6,0,0,0,.754-1.359v-1.283A1.677,1.677,0,0,0,96.789,309.027Zm-7.346-16.669h19.006l0,21.383h-.295a4.056,4.056,0,0,0-.592-.416l-4.4-2.5v-.585a7.054,7.054,0,0,0,1.212-2.6.333.333,0,0,1,.1-.172,2.685,2.685,0,0,0,.84-1.949v-1.462a2.789,2.789,0,0,0-.325-1.291l-.063-.107a.354.354,0,0,1-.041-.158v-2.1a4.569,4.569,0,0,0-4.645-4.478H97.651a4.569,4.569,0,0,0-4.645,4.478v2.1c0,.046-.013.1-.009.1h0l-.129.228a2.74,2.74,0,0,0-.291,1.229v1.462a2.693,2.693,0,0,0,.848,1.957.346.346,0,0,1,.1.186,6.958,6.958,0,0,0,1.207,2.574v.584l-4.4,2.5a4.129,4.129,0,0,0-.594.415h-.292Z",
    transform: "translate(-81.126 -251.969)",
    fill: "#7821a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_382",
    "data-name": "Trazado 382",
    d: "M146.231,325.3v5.94a1.188,1.188,0,1,0,2.376,0V325.3a1.188,1.188,0,0,0-2.376,0Z",
    transform: "translate(-109.406 -268.284)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_383",
    "data-name": "Trazado 383",
    d: "M155.334,325.3v5.94a1.188,1.188,0,1,0,2.376,0V325.3a1.188,1.188,0,0,0-2.376,0Z",
    transform: "translate(-113.757 -268.284)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_384",
    "data-name": "Trazado 384",
    d: "M165.624,324.116a1.187,1.187,0,0,0-1.188,1.188v5.94a1.188,1.188,0,1,0,2.376,0V325.3a1.187,1.187,0,0,0-1.188-1.188Z",
    transform: "translate(-118.107 -268.284)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_385",
    "data-name": "Trazado 385",
    d: "M173.538,325.3v5.94a1.188,1.188,0,1,0,2.376,0V325.3a1.188,1.188,0,0,0-2.376,0Z",
    transform: "translate(-122.458 -268.284)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_386",
    "data-name": "Trazado 386",
    d: "M182.641,325.3v5.94a1.188,1.188,0,1,0,2.375,0V325.3a1.188,1.188,0,0,0-2.375,0Z",
    transform: "translate(-126.809 -268.284)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_387",
    "data-name": "Trazado 387",
    d: "M192.931,324.116a1.187,1.187,0,0,0-1.188,1.188v5.94a1.188,1.188,0,1,0,2.376,0V325.3a1.187,1.187,0,0,0-1.188-1.188Z",
    transform: "translate(-131.159 -268.284)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_388",
    "data-name": "Trazado 388",
    d: "M161.775,292.257H145.144a1.188,1.188,0,0,0,0,2.376h16.631a1.188,1.188,0,0,0,0-2.376Z",
    transform: "translate(-108.318 -253.056)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_389",
    "data-name": "Trazado 389",
    d: "M189.667,294.634a1.188,1.188,0,1,0,0-2.376H186.1a1.188,1.188,0,1,0,0,2.376Z",
    transform: "translate(-127.896 -253.056)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_390",
    "data-name": "Trazado 390",
    d: "M159.885,302.546a1.188,1.188,0,0,0,1.188,1.188H177.7a1.188,1.188,0,1,0,0-2.376H161.073a1.187,1.187,0,0,0-1.188,1.188Z",
    transform: "translate(-115.932 -257.406)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_391",
    "data-name": "Trazado 391",
    d: "M145.144,303.734h3.564a1.188,1.188,0,1,0,0-2.376h-3.564a1.188,1.188,0,0,0,0,2.376Z",
    transform: "translate(-108.318 -257.406)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_392",
    "data-name": "Trazado 392",
    d: "M145.144,312.838h10.692a1.188,1.188,0,0,0,0-2.376H145.144a1.188,1.188,0,0,0,0,2.376Z",
    transform: "translate(-108.318 -261.758)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_393",
    "data-name": "Trazado 393",
    d: "M140.693,256.149a3.564,3.564,0,1,0-3.564-3.564A3.564,3.564,0,0,0,140.693,256.149Zm0-4.751a1.188,1.188,0,1,1-1.188,1.188A1.188,1.188,0,0,1,140.693,251.4Z",
    transform: "translate(-105.055 -232.391)",
    fill: "#264ecc"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02IconoProgramaInsignias);
export default __webpack_public_path__ + "static/media/02-icono-programa-insignias.afeafab38e936e8563097418e2098587.svg";
export { ForwardRef as ReactComponent };